import { render, staticRenderFns } from "./EditAnalisisSampel.vue?vue&type=template&id=67e3a9f7&scoped=true&"
import script from "./EditAnalisisSampel.vue?vue&type=script&lang=js&"
export * from "./EditAnalisisSampel.vue?vue&type=script&lang=js&"
import style0 from "./EditAnalisisSampel.vue?vue&type=style&index=0&id=67e3a9f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e3a9f7",
  null
  
)

export default component.exports